module.exports = __webpack_public_path__ + "img/less-than-equal.ad2585af.svg";